import { useHistory } from 'react-router-dom';

import PPPageHeader from '../../components/pageHeader/PPPageHeader';
import useStore from '../../store/useStore';
import ProductAdd from './Add';
import { groupProductDraftKey, useClearDraftOnLeave } from './draft';
import { ProductProvider } from './ProductDataContext';

const routes = [
  {
    path: '/product-settings',
    breadcrumbName: 'Бараа',
  },
  {
    path: 'first',
    breadcrumbName: 'Багц бараа',
  },
];

const ProductStep = () => {
  const history = useHistory();

  /**
   * Draft-ыг merchant-аар салгана — merchant солиход (нэг таб дотор reload
   * болдог тул) өмнөх merchant дээр бөглөсөн мэдээлэл сэргэхгүй.
   */
  const merchantCode = useStore((state) => state.user.merchantCode);
  const draftKey = groupProductDraftKey(merchantCode);
  // Хуудсаас гармагц бөглөсөн мэдээлэл цэвэрлэгдэнэ (refresh дээр сэргэсэн хэвээр)
  useClearDraftOnLeave(draftKey);

  return (
    <>
      <PPPageHeader
        title="Багц бараа үүсгэх"
        breadcrumb={{ routes }}
        onBack={() =>
          history.push({
            pathname: '/merchant/group/product/list',
          })
        }
      />
      {/**
       * `key` нь draftKey — merchant солиход provider remount болж, өмнөх
       * merchant-ийн төлөв шинэ draft key дор бичигдэхээс сэргийлнэ.
       */}
      <ProductProvider key={draftKey} draftKey={draftKey}>
        <ProductAdd />
      </ProductProvider>
    </>
  );
};

export default ProductStep;
